<template>
  <div>
    <ContentHeader :showBack="false" :perfectNavList="employeeLevel > 50 ? buPerfectNavList : rePerfectNavList" />

    <div class="content-container">
      <router-view @handleRefresh="getTodo"></router-view>
    </div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade'
import ContentHeader from '@/components/content-header'
import { mapGetters } from 'vuex'
export default {
  name: 'perfect-home',
  components: {
    ContentHeader
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  data () {
    return {
      buPerfectNavList: [
        // {
        //   path: '/trade/perfect-theme2021-list',
        //   title: '任务配置2021'
        // },
        {
          path: '/trade/perfect-bu-config-list',
          title: '任务配置'
        },
        {
          path: '/trade/perfect-budget',
          title: '预算配置'
        },
        {
          path: '/trade/perfect-theme-approve',
          title: '活动审批'
        }
      ],
      rePerfectNavList: [
        {
          path: '/trade/perfect-region-config-list',
          title: '活动配置'
        },
        {
          path: '/trade/perfect-my-budget',
          title: '我的预算'
        }
      ],
      employeeLevel: null
    }
  },
  created () {
    this.employeeLevel = this.userInfo.employeeLevel
    this.getTodo()
  },
  methods: {
  // 待办统计
    getTodo () {
      if (this.employeeLevel === 60) {
        tradeApi.activeTodo().then(res => {
          if (res.data.resultCode === '0' && res.data.resultData.tradePerfectThemeDefineApproveCount !== 0) {
            this.buPerfectNavList[2].title = '活动审批（' + res.data.resultData.tradePerfectThemeDefineApproveCount + ')'
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
